import React from "react"
import { rhythm } from "../../../utils/typography"
import { SocialShare } from "./social-share"
import { SponsorButton } from "./sponsor-button"

export const PostBody = ({ html, sponsor }) => (
         <div>
           <div className={"post-content"} dangerouslySetInnerHTML={{ __html: html }} />
           <SocialShare />
           {!!sponsor.buyMeACoffeeId && (
             <SponsorButton sponsorId={sponsor.buyMeACoffeeId} />
           )}
           <hr style={{ marginBottom: rhythm(1) }} />
         </div>
       )
